/** Популярные города → регион для eDost (поле deliveryCityData.region). */
export const MAIN_CITY_REGIONS: Record<string, string> = {
  Москва: "Московская",
  "Санкт-Петербург": "Ленинградская",
  Барнаул: "Алтайский",
  Владивосток: "Приморский",
  Волгоград: "Волгоградская",
  Воронеж: "Воронежская",
  Екатеринбург: "Свердловская",
  Ижевск: "Удмуртская",
  Иркутск: "Иркутская",
  Казань: "Татарстан",
  Кемерово: "Кемеровская",
  Киров: "Кировская",
  Краснодар: "Краснодарский",
  Красноярск: "Красноярский",
  Липецк: "Липецкая",
  Махачкала: "Дагестан",
  "Набережные Челны": "Татарстан",
  "Нижний Новгород": "Нижегородская",
  Новокузнецк: "Кемеровская",
  Новосибирск: "Новосибирская",
  Омск: "Омская",
  Оренбург: "Оренбургская",
  Пенза: "Пензенская",
  Пермь: "Пермский",
  Петрозаводск: "Карелия",
  "Ростов-на-Дону": "Ростовская",
  Рязань: "Рязанская",
  Самара: "Самарская",
  Саратов: "Саратовская",
  Севастополь: "Севастополь",
  Ставрополь: "Ставропольский",
  Тольятти: "Самарская",
  Томск: "Томская",
  Тюмень: "Тюменская",
  Ульяновск: "Ульяновская",
  Уфа: "Башкортостан",
  Хабаровск: "Хабаровский",
  Чебоксары: "Чувашская",
  Челябинск: "Челябинская",
  Ярославль: "Ярославская",
};

export const MAIN_CITIES = Object.keys(MAIN_CITY_REGIONS);

/** Синхронный резолв региона по городу (клиент + сервер). */
export function resolveEdostRegionByCity(cityName: string): string {
  const city = cityName?.trim();
  if (!city) {
    return "";
  }
  return MAIN_CITY_REGIONS[city] ?? "";
}
